import { render, staticRenderFns } from "./CapacityLogger.vue?vue&type=template&id=0362a6fb"
import script from "./CapacityLogger.vue?vue&type=script&lang=js"
export * from "./CapacityLogger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports